export enum AnfrageTyp {
  DIREKTABSCHLUSS = 'DIREKTABSCHLUSS',
  ANGEBOT = 'ANGEBOT',
}
